import styled from 'styled-components';
import { Typography } from '@mui/material';
import { Flex } from '@elementary/common-ui/components';
import CopyButton from 'shared/components/CopyButton';
import { isIncidentReadOnly } from '../../utils/incidentState';
import type { IncidentDetail } from '../../types';

const TitleRow = styled(Flex)`
  align-items: flex-start;
  gap: 8px;
`;

const Title = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  word-break: break-word;
`;

type Props = {
  incident: IncidentDetail;
};

const IncidentHeader = ({ incident }: Props) => {
  const isReadOnly = isIncidentReadOnly(incident);

  return (
    <TitleRow>
      <Title>{incident.title}</Title>
      {!isReadOnly && (
        <CopyButton
          textToCopy={incident.title}
          sx={{ height: '20px', width: '20px', flexShrink: 0 }}
        />
      )}
    </TitleRow>
  );
};

export default IncidentHeader;
